/**
 * LAUNCH-BUTTON
 * Big button for modals and large launch pad actions
 */

import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ReactNode } from "react"

interface Props {
  description?: string
  icon?: IconDefinition
  iconBackground?: string
  iconColor?: string
  isCta?: boolean
  isRow?: boolean
  ctaColor?: string
  preTitle?: string
  title: ReactNode
  onClick: () => void
}

export default function LaunchButton({
  description,
  icon,
  iconBackground,
  iconColor = "#0E5AA7",
  isCta,
  isRow,
  ctaColor,
  preTitle,
  title,
  onClick
}: Props) {
  const accentColor = ctaColor ?? "#0E5AA7"
  const resolvedIconBackground = iconBackground ?? (isCta ? accentColor : "#EAF2FB")
  const resolvedIconColor = isCta ? "white" : iconColor

  return (
    <button
      type="button"
      onClick={() => onClick()}
      className={`group mb-0 relative overflow-hidden flex bg-white _hover ${
        isRow
          ? "min-h-[92px] w-full items-center rounded-[12px] px-20 py-10 text-left"
          : "min-h-[170px] flex-1 flex-col items-center justify-center rounded-[12px] p-20 text-center"
      }`}
      style={{ border: `1px solid ${isCta ? accentColor : "#E2E8F0"}` }}>
      <span
        className={`relative z-10 flex shrink-0 items-center justify-center ${
          isRow ? "mr-20 h-[54px] w-[54px] rounded-[12px]" : "mb-[15px] h-[58px] w-[58px] rounded-[12px]"
        }`}
        style={{ backgroundColor: resolvedIconBackground }}>
        {icon && <FontAwesomeIcon icon={icon} style={{ color: resolvedIconColor, fontSize: isRow ? 24 : 26 }} />}
      </span>

      <div className={`relative z-10 min-w-0 text-slate-900 ${isRow ? "flex-1" : ""}`}>
        {preTitle && <div className="grey-t text-sm leading-tight">{preTitle}</div>}
        <div className="text-lg font-normal">{title}</div>
        {description && <div className="grey-t mt-1 text-sm leading-snug">{description}</div>}
      </div>

      {isRow && <FontAwesomeIcon className="ml-20 text-lg text-slate-400" icon={faChevronRight} />}
    </button>
  )
}
